/*jshint esversion: 11 */
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import moment from 'moment';

function buildFilename(record) {
  const batchName = (record?.batch?.name || 'batch')
    .replace(/[^\w\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-');
  const weekStart = record?.start_date
    ? moment(record.start_date).format('DD-MMM-YYYY')
    : 'week';
  return `weekly-log_${batchName}_${weekStart}.pdf`;
}

export async function exportWeeklyLogPdf(element, record) {
  if (!element) {
    throw new Error('Export content is not available');
  }

  const canvas = await html2canvas(element, {
    scale: 2,
    useCORS: true,
    backgroundColor: '#ffffff',
    logging: false
  });

  const imgData = canvas.toDataURL('image/png');
  const pdf = new jsPDF('l', 'mm', 'a4');
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const imgWidth = pageWidth;
  const imgHeight = (canvas.height * imgWidth) / canvas.width;

  let heightLeft = imgHeight;
  let position = 0;

  pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
  heightLeft -= pageHeight;

  while (heightLeft > 0) {
    position = heightLeft - imgHeight;
    pdf.addPage();
    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;
  }

  pdf.save(buildFilename(record));
}
